<template>
  <div v-if="headlinesExist" class="carousel-component" :class="{'fullscreen': fullscreen !== undefined}">
    <ul>
      <!-- <li class="image" :class="{'show': isVisible(i)}" v-for="(item, i) in headlines" :key="item.idfwheadline" :style="{backgroundImage: 'url(' + item.imageurl + ')'}"></li> -->
      <li class="image" :class="{'show': isVisible(i)}" v-for="(item, i) in headlines" :key="item.idfwheadline">
        <img :src="item.imageurl" alt="" onerror="arguments[0].currentTarget.style.display='none'">
      </li>
    </ul>
  </div>
</template>

<script>
  import store from '@/store'
  import config from '@/config'

  import BettingOffer from '@/components/mixins/BettingOffer'
  import Screen from '@/components/mixins/Screen'

  export default {
    name: 'carousel',
    props: [
      'category',
      'fullscreen'
    ],
    mixins: [
      Screen,
      BettingOffer
    ],

    components: {
    },

    data () {
      return {
        index: 0,
        timer: 0,
        interval: config.app.carouselRotationInterval
      }
    },

    computed: {
      allHeadlines () {
        return store.getters['cduState/getBoNavigationHeadlines']
      },
      headlines () {
        return (this.allHeadlines && this.allHeadlines.filter(item => item.categoryname === this.category)) || []
      },
      headlinesNumber () {
        return this.headlines.length
      },
      headlinesExist () {
        return this.headlinesNumber > 0
      },
      isFullscreen () {
        return this.fullscreen !== undefined
      }
    },

    methods: {

      stop () {
        clearTimeout(this.timer)
      },
      start () {
        var context = this
        this.index = 0

        if (this.headlinesNumber > 1) {
          context.timer = setTimeout(function rotate () {
            if (context.isLast()) {
              context.index = 0
            } else {
              context.index++
            }

            context.timer = setTimeout(rotate, context.interval)
          }, this.interval)
        }
      },

      isLast () {
        return this.index === this.headlinesNumber - 1
      },
      isVisible (index) {
        return this.index === index
      }
    },

    mounted () {
      this.start()
    },

    destroyed () {
      this.stop()
    },

    watch: {
      headlinesNumber () {
        this.stop()
        this.start()
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .carousel-component
    ul
    .image
    &.fullscreen
      width: 100%
      height: 100%
      padding: 0
      margin: 0

    .image
      display: flex
      align-items: center
      justify-content: center
      position: absolute
      transition: opacity 1s
      background-position: center
      background-repeat: no-repeat
      background-size: contain
      list-style: none
      opacity: 0

      img
        max-width: 100%
        max-height: 100%

      &.show
        opacity: 1

    &.fullscreen
      position: absolute
      background: #111
      top: 0
      left: 0
      z-index: -10
</style>



// WEBPACK FOOTER //
// src/components/cdu/headlines/carousel.vue